
export enum UserKind {
  VIP = 1,
  User = 2,
  Admin = 4,
  PowerUser = 16
}
